import { type FC } from 'react';

/**
 * 책임 있는 추천 고지 — 랜덤/행운/스마트 추천/통계 화면에 일관되게 표시하는
 * 작은 안내 영역. 로또 추첨의 확률적 성격을 중립적으로 안내한다.
 */
const ResponsibleNotice: FC = () => {
  return (
    <div className="w-full max-w-3xl mx-auto px-4 md:px-6 mt-6">
      <p className="flex items-start gap-2 text-xs text-foreground-500 leading-relaxed">
        <i className="ri-information-line text-sm text-foreground-400 mt-px shrink-0"></i>
        <span>
          로또 추첨은 독립적인 확률 사건이며 모든 유효 조합의 당첨 확률은 같습니다.
          과거 통계와 추천은 오락·참고용이며 당첨을 보장하지 않습니다.
        </span>
      </p>
    </div>
  );
};

export default ResponsibleNotice;